<template lang="pug">
#enroll
  .container
    breadcrumb(v-bind:pageName="pageName")
    h4.text-center 課程報名表
    #accordion.mb-5.mt-3
      .news_card.mb-4.mt-3.border-radius-10
        .row
          .col-12.px-0
            h5.text-center.border-bottom.pb-2 請確認以下訂單金額
        .row.rounded.bg-light.py-3.mt-3(v-if="discount.length > 0")
          .discount_title.col-12(
            v-if="!isGroupEnroll && programProductGroupSelect.is_top_basketball_self"
          )
            font-awesome-icon.mr-1(
              :icon="['fas', 'ticket-alt']",
              style="color: #b5b5b5"
            )
            span 優惠券
          .discount_options.col-12.mt-1(
            v-if="!isGroupEnroll && programProductGroupSelect.is_top_basketball_self"
          )
            li(
              v-for="(discountItem, index) in discount",
              :key="index",
              :class="{ selected: discountSelect.includes(discountItem) }"
            ) {{ discountItem.name }}
          .discount_title.col-12(
            v-if="!isGroupEnroll && !programProductGroupSelect.is_top_basketball_self"
          )
            font-awesome-icon.mr-1(
              :icon="['fas', 'ticket-alt']",
              style="color: #b5b5b5"
            )
            span 優惠券（請選擇）
          .discount_options.col-12.mt-1(
            v-if="!isGroupEnroll && !programProductGroupSelect.is_top_basketball_self"
          )
            li(
              v-for="(discountItem, index) in discount",
              @click="onDiscountSelect(discountItem)",
              :key="index",
              :class="{ selected: discountSelect.includes(discountItem) }"
            ) {{ discountItem.name }}
          .discount_title.col-12.mt-3(v-if="isGroupEnroll")
            font-awesome-icon.mr-1(
              :icon="['fas', 'ticket-alt']",
              style="color: #b5b5b5"
            )
            span 團體優惠券（請選擇）
          .discount_options.col-12.mt-1(v-if="isGroupEnroll")
            li(
              v-for="(discountItem, index) in discount",
              :key="index",
              @click="onDiscountSelect(discountItem)",
              :class="{ selected: discountSelect.includes(discountItem) }"
            ) {{ discountItem.name }}
        .purchase_content
          h5.mt-5 購買課程
          p.course_group.mt-3 {{ programProductGroupSelect.name }}
          p(v-for="product in programProductsSelectList") {{ product.name }} X{{ totalStudent }} (NT. {{ product.total_price * totalStudent }})

          h5.mt-5(v-if="selectExtraProductsList.length > 0") 加購商品
          .product_wrapper.mt-3(v-if="selectExtraProductsList.length > 0")
            .item_detail.d-flex.justify-content-between.align-items-center(
              v-for="extraProduct in selectExtraProductsList"
            )
              img(v-if="extraProduct.photo", :src="extraProduct.photo.image")
              .extra_product_info
                p {{ extraProduct.name }}
                .extra_product_counter.d-flex.align-items-center
                  span.mr-2 數量
                  input.form-control.extra_product_counter(
                    required="true",
                    type="number",
                    min="1",
                    @change="extraProductAmountChange(extraProduct)",
                    v-model="extraProduct.extraProductCount"
                  )
              p.price $
                span {{ extraProduct.total_price * extraProduct.extraProductCount }}
          .discount_content(v-if="discountDetailList.length > 0")
            h5.mt-5 優惠券
            .d-flex.justify-content-between.align-items-center.mt-3(
              v-for="(discountDetail, index) in discountDetailList"
            )
              p {{ discountDetail.name }}
              p.price -{{ discountDetail.price }}
          hr.mt-5
          .total.d-flex.justify-content-between
            h5 總計
            p $
              span {{ total }}

    #accordion.mb-5.mt-3
      .news_card.mb-4.mt-3.border-radius-10
        .row
          .col-12.px-0
            h5.text-center.pb-2 報名資訊
        .row.mt-3.position-relative
          .container.single(v-if="totalStudent == 1")
            .row.align-items-center.justify-content-center.justify-content-md-between
              .col-md-auto.selector
                select(
                  name="commonContactPersonType",
                  v-model="singleStudent.generalSelect",
                  @change="singleGeneralChange"
                )
                  option(value="") 自行輸入報名資訊
                  option(
                    v-for="(general, index) in userInfo.apply_targets",
                    :value="general"
                  ) 常用報名-{{ general.name }}
              .col-md-auto.mt-3.mt-md-0
                .checkbox.d-flex.align-items-center(
                  v-if="!singleStudent.generalSelect"
                )
                  input(type="checkbox", v-model="singleStudent.addNewGeneral")
                  span.alert_msg 新增至常用報名
            .row.mb-5
              .col-md-6.left
                span.title 學生姓名
                input.form-control(
                  required="true",
                  type="text",
                  placeholder="請輸入學生姓名",
                  v-model="singleStudent.studentName"
                )
                span.title 聯絡人電話
                input.form-control(
                  required="true",
                  type="text",
                  placeholder="請輸入您的聯絡電話",
                  v-model="singleStudent.contactPhone"
                )
                span.title 就讀學校
                input.form-control(
                  required="true",
                  type="text",
                  placeholder="請輸入學生就讀學校",
                  v-model="singleStudent.school"
                )
                span.title 就讀年級
                input.form-control(
                  required="true",
                  type="text",
                  placeholder="請輸入學生年級",
                  v-model="singleStudent.grade"
                )
                span.title 出生年月日(保險用)
                input.form-control(
                  required="true",
                  type="text",
                  placeholder="請輸入出生年月日, 格式: 2000/01/01",
                  v-model="singleStudent.studentBirthday",
                  @input="birthdayChange('S', singleStudent.studentBirthday, singleStudent)"
                )
                p.valid(v-if="singleStudent.birthdayValid") *請輸入正確的出生年月日 ex: 2000/01/01
                span.title 身份證字號(保險用)
                input.form-control(
                  required="true",
                  type="text",
                  placeholder="請輸入學生身分證字號",
                  v-model="singleStudent.studentID",
                  maxlength="10",
                )
              .col-md-6.right
                span.title 法定代理人姓名(保險用)
                input.form-control(
                  required="true",
                  type="text",
                  placeholder="請輸入法定代理人姓名",
                  v-model="singleStudent.parentName"
                )
                span.title 法定代理人出生年月日(保險用)
                input.form-control(
                  required="true",
                  type="text",
                  placeholder="請輸入法定代理人出生年月日, 格式: 2000/01/01",
                  v-model="singleStudent.parentBirthday",
                  @input="birthdayChange('P', singleStudent.parentBirthday, singleStudent)"
                )
                p.valid(v-if="singleStudent.parentBirthdayValid") *請輸入正確的出生年月日 ex: 2000/01/01
                span.title 法定代理人身分證字號(保險用)
                input.form-control(
                  required="true",
                  type="text",
                  placeholder="請輸入法定代理人身分證字號",
                  v-model="singleStudent.parentID",
                )
                span.title 籃球學習經驗描述（參加過社團或其他籃球營隊）
                input.form-control(
                  required="true",
                  type="text",
                  placeholder="請輸入學生的籃球學習經驗描述",
                  v-model="singleStudent.basketball_experience"
                )
                span.title 課程主要目標
                input.form-control(
                  required="true",
                  type="text",
                  placeholder="請輸入課程主要目標",
                  v-model="singleStudent.basketball_goal"
                )
                span.title 如何得知訊息
                select.hear_from.form-control(
                  placeholder="請選擇",
                  v-model="singleStudent.contact_from"
                )
                  option(value="NONE") 無
                  option(value="FACEBOOK") Facebook
                  option(value="INSTAGRAM") Instagram
                  option(value="LINE") Line
                  option(value="GOOGLE") Google搜尋
                  option(value="FRIEND") 親友介紹
                  option(value="OTHER") 其他
            .row.border-top
              .col-12
                span.title 聯絡人LINE帳號ID
                span.mt-1 (請務必打開ID並留下您的ID，會有專人向您確認報名資訊，如沒有打開ID視同放棄報名及優惠)
                input.form-control(
                  required="true",
                  type="text",
                  placeholder="請輸入 LINE 帳號 ID",
                  v-model="singleStudent.lineID"
                )
                span.title 健康狀況
                .radio_btn.mt-2.flex_h
                  input(
                    type="radio",
                    name="healh",
                    value="遺傳疾病",
                    v-model="singleStudent.healthy"
                  )
                  span 遺傳疾病
                .radio_btn.flex_h
                  input(
                    type="radio",
                    name="healh",
                    value="心臟疾病",
                    v-model="singleStudent.healthy"
                  ) 
                  span 心臟疾病
                .radio_btn.flex_h
                  input(
                    type="radio",
                    name="healh",
                    value="氣喘",
                    v-model="singleStudent.healthy"
                  ) 
                  span 氣喘
                .radio_btn.flex_h
                  input(
                    type="radio",
                    name="healh",
                    value="癲癇",
                    v-model="singleStudent.healthy"
                  ) 
                  span 癲癇
                .radio_btn.flex_h
                  input(
                    type="radio",
                    name="healh",
                    value="無",
                    v-model="singleStudent.healthy"
                  ) 
                  span 無
                span.title 食物過敏(小朋友不能吃的及吃了會過敏的請註明，沒有請填無)
                input.form-control(
                  required="true",
                  type="text",
                  v-model="singleStudent.allergy"
                )
          b-tabs.multiple.w-100(v-if="totalStudent != 1", v-model="tabIndex")
            b-tab(
              v-for="(tab, index) in tabs",
              :key="index",
              :title="'學生' + (index + 1)"
            )
              .container
                .row.mt-3
                  .col-auto.ml-auto
                    b-button(
                      size="sm",
                      variant="danger",
                      @click="closeTab(index)"
                    ) 刪除
                .row.align-items-center.justify-content-center.justify-content-md-between.mt-3
                  .col-md-auto.selector
                    select(
                      name="commonContactPersonType",
                      v-model="multipleStudents[index].generalSelect",
                      @change="multipleGeneralChange(index)"
                    )
                      option(value="") 自行輸入報名資訊
                      option(
                        v-for="(general, index) in userInfo.apply_targets",
                        :value="general"
                      ) 常用報名-{{ general.name }}
                  .col-md-auto.mt-3.mt-md-0
                    .checkbox.d-flex.align-items-center(
                      v-if="!multipleStudents[index].generalSelect"
                    )
                      input(
                        type="checkbox",
                        v-model="multipleStudents[index].addNewGeneral"
                      )
                      span 新增至常用報名
                .row.mb-5
                  .col-md-6.left
                    span.title 學生{{ index + 1 }}姓名
                    input.form-control(
                      required="true",
                      type="text",
                      placeholder="請輸入學生姓名",
                      v-model="multipleStudents[index].studentName"
                    )
                    span.title 聯絡人電話
                    input.form-control(
                      required="true",
                      type="text",
                      placeholder="請輸入您的聯絡電話",
                      v-model="multipleStudents[index].contactPhone"
                    )
                    span.title 就讀學校
                    input.form-control(
                      required="true",
                      type="text",
                      placeholder="請輸入學生就讀學校",
                      v-model="multipleStudents[index].school"
                    )
                    span.title 就讀年級
                    input.form-control(
                      required="true",
                      type="text",
                      placeholder="請輸入學生年級",
                      v-model="multipleStudents[index].grade"
                    )
                    span.title 出生年月日(保險用)
                    input.form-control(
                      required="true",
                      type="text",
                      placeholder="請輸入學生出生年月日",
                      v-model="multipleStudents[index].studentBirthday",
                      @input="birthdayChange('S', multipleStudents[index].studentBirthday, multipleStudents[index])"
                    )
                    p.valid(v-if="multipleStudents[index].birthdayValid") *請輸入正確的出生年月日 ex: 2000/01/01
                    span.title 身份證字號(保險用)
                    input.form-control(
                      required="true",
                      type="text",
                      placeholder="請輸入學生身分證字號",
                      v-model="multipleStudents[index].studentID",
                      maxlength="10",
                      @input="personIdChange('S', multipleStudents[index].studentID, multipleStudents[index])"
                    )
                    p.valid(v-if="multipleStudents[index].personIdValid") *請輸入正確的身分證字號
                  .col-md-6.right
                    span.title 法定代理人姓名(保險用)
                    input.form-control(
                      required="true",
                      type="text",
                      placeholder="請輸入法定代理人姓名",
                      v-model="multipleStudents[index].parentName"
                    )
                    span.title 法定代理人出生年月日(保險用)
                    input.form-control(
                      required="true",
                      type="text",
                      placeholder="請輸入法定代理人出生年月日",
                      v-model="multipleStudents[index].parentBirthday",
                      @input="birthdayChange('P', multipleStudents[index].parentBirthday, multipleStudents[index])"
                    )
                    p.valid(v-if="multipleStudents[index].parentBirthdayValid") *請輸入正確的出生年月日 ex: 2000/01/01
                    span.title 法定代理人身分證字號(保險用)
                    input.form-control(
                      required="true",
                      type="text",
                      placeholder="請輸入法定代理人身分證字號",
                      v-model="multipleStudents[index].parentID",
                      @input="personIdChange('P', multipleStudents[index].parentID, multipleStudents[index])"
                    )
                    p.valid(v-if="multipleStudents[index].parentIdValid") *請輸入正確的身分證字號
                    span.title 籃球學習經驗描述（參加過社團或其他籃球營隊）
                    input.form-control(
                      required="true",
                      type="text",
                      placeholder="請輸入學生的籃球學習經驗描述",
                      v-model="multipleStudents[index].basketball_experience"
                    )
                    span.title 課程主要目標
                    input.form-control(
                      required="true",
                      type="text",
                      placeholder="請輸入課程主要目標",
                      v-model="multipleStudents[index].basketball_goal"
                    )
                    span.title 如何得知訊息
                    select.hear_from.form-control(
                      placeholder="請選擇",
                      v-model="multipleStudents[index].contact_from"
                    )
                      option(value="NONE") 無
                      option(value="FACEBOOK") Facebook
                      option(value="INSTAGRAM") Instagram
                      option(value="LINE") Line
                      option(value="GOOGLE") Google搜尋
                      option(value="FRIEND") 親友介紹
                      option(value="OTHER") 其他

                .row.border-top
                  .col-12
                    span.title 聯絡人LINE帳號ID
                    span.mt-1 (請務必打開ID並留下您的ID，會有專人向您確認報名資訊，如沒有打開ID視同放棄報名及優惠)
                    input.form-control(
                      required="true",
                      type="text",
                      placeholder="請輸入 LINE 帳號 ID",
                      v-model="multipleStudents[index].lineID"
                    )

                    span.title 健康狀況
                    .radio_btn.mt-2.flex_h
                      input(
                        type="radio",
                        :name="'health' + index",
                        value="遺傳疾病",
                        v-model="multipleStudents[index].healthy"
                      )
                      span 遺傳疾病
                    .radio_btn.flex_h
                      input(
                        type="radio",
                        :name="'health' + index",
                        value="心臟疾病",
                        v-model="multipleStudents[index].healthy"
                      ) 
                      span 心臟疾病
                    .radio_btn.flex_h
                      input(
                        type="radio",
                        :name="'health' + index",
                        value="氣喘",
                        v-model="multipleStudents[index].healthy"
                      ) 
                      span 氣喘
                    .radio_btn.flex_h
                      input(
                        type="radio",
                        :name="'health' + index",
                        value="癲癇",
                        v-model="multipleStudents[index].healthy"
                      ) 
                      span 癲癇
                    .radio_btn.flex_h
                      input(
                        type="radio",
                        :name="'health' + index",
                        value="無",
                        v-model="multipleStudents[index].healthy"
                      ) 
                      span 無

                    span.title 食物過敏(小朋友不能吃的及吃了會過敏的請註明，沒有請填無)
                    input.form-control(
                      required="true",
                      type="text",
                      v-model="multipleStudents[index].allergy"
                    )
            template(#tabs-end="", v-if="tabCounter < totalStudent")
              b-nav-item(
                role="presentation",
                @click.prevent="newTab",
                href="#"
              )
                b +
            template(#empty="")
              .text-center.text-muted.mt-3 請點擊"+"號新增學生資訊
    #accordion.mb-5.mt-3
      .news_card.mb-4.border-radius-10
        .row
          .col-12
            h4.text-center {{ programProductGroupSelect.name }}
        .row.mt-3.mt-md-0
          .p-3.border.rounded.w-100(v-html="programProductGroupSelect.rule")
        .row.mt-3
          .col-12.text-center
            h5.agree 您是否同意以上規範
              span
                input(type="checkbox", v-model="isAgree")
              span 同意
      .row.submit-btn.mt-3.justify-content-center
        .col-12.text-center
          .send_btn(@click="onConfirmBtnClick") 確認送出
  dialog-loading(v-if="loadingDialogShow", :content="loadingContent")
  custom-footer
</template>

<script>
import CustomFooter from "@/components/common/Footer";
import EnrollConfirmDialog from "@/components/enroll/EnrollConfirmDialog";
import DialogStandard from "@/components/enroll/DialogStandard";
import Breadcrumb from "@/components/common/Breadcrumb";
import { errorMessage } from "@/utils/message";
import { getUserInfo, updateUserInfo } from "@/api/user";
import { validID, validDateExist } from "@/utils/validate";
import {
  getProgramProductGroupList,
  getDiscountList,
  getProgramProductByID,
  confirmOrder,
} from "@/api/ecommerce";
import {
  getOrderProgramProductGroupSelect,
  getOrderProductSelect,
  getOrderSelectExtraProducts,
  getIsGroupEnroll,
} from "@/utils/auth";
import DialogLoading from "@/components/dialog/DialogLoading";

export default {
  name: "EnrollInfo",
  components: {
    "custom-footer": CustomFooter,
    breadcrumb: Breadcrumb,
    "enroll-confirm-dialog": EnrollConfirmDialog,
    "dialog-standard": DialogStandard,
    "dialog-loading": DialogLoading,
  },
  data() {
    return {
      pageName: "課程報名表",
      programProductGroupList: [],
      programProductGroupID: -1,
      programProductGroupSelect: {},
      programProductsSelectIDList: [],
      programProductsSelectList: [],

      selectExtraProductsIDList: [],
      selectExtraProductsList: [],
      isGroupEnroll: null,

      discount: {},
      discountSelect: [],
      discountDetailList: [],
      isValueMember: false,

      total: 0,
      totalStudent: 1,

      tabIndex: 0,
      tabs: [],
      tabCounter: 0,
      userInfo: {},

      singleStudent: {
        studentName: "",
        studentBirthday: "",
        contactPhone: "",
        studentID: "",
        school: "",
        parentName: "",
        parentBirthday: "",
        parentID: "",
        grade: "",
        lineID: "",
        healthy: "",
        allergy: "",
        contact_from: "NONE",
        basketball_experience: "",
        basketball_goal: "",

        parentBirthdayValid: false,
        parentIdValid: false,
        birthdayValid: false,
        personIdValid: false,
        generalSelect: "",
        addNewGeneral: false,
      },

      student: {
        studentName: "",
        studentBirthday: "",
        contactPhone: "",
        studentID: "",
        school: "",
        parentName: "",
        parentBirthday: "",
        parentID: "",
        grade: "",
        lineID: "",
        healthy: "",
        allergy: "",
        contact_from: "NONE",
        basketball_experience: "",
        basketball_goal: "",

        parentBirthdayValid: false,
        parentIdValid: false,
        birthdayValid: false,
        personIdValid: false,
        generalSelect: "",
        addNewGeneral: false,
      },

      multipleStudents: [],

      isAgree: false,
      extraProductCount: 1,

      loadingDialogShow: false,
      loadingContent: "傳送中....",
    };
  },
  created() {
    this.programProductGroupID = JSON.parse(
      getOrderProgramProductGroupSelect()
    );
    this.programProductsSelectIDList = JSON.parse(getOrderProductSelect());
    this.selectExtraProductsIDList = JSON.parse(getOrderSelectExtraProducts());
    this.isGroupEnroll = JSON.parse(getIsGroupEnroll());

    this.getProgramProductGroupList();
    this.getUserInfo();
    this.getProductDetail();
    this.getExtraProductDetail();
  },
  methods: {
    extraProductAmountChange(extraProduct) {
      if (extraProduct.extraProductCount < 1) {
        extraProduct.extraProductCount = 1;
      }
      this.getTotalPrice();
    },
    getProgramProductGroupList() {
      getProgramProductGroupList().then((response) => {
        this.programProductGroupList = response.data;

        for (let index in this.programProductGroupList) {
          let temp = this.programProductGroupList[index];
          if (this.programProductGroupID == temp.id) {
            this.programProductGroupSelect = temp;
          }
        }
        this.getDiscountList();
      });
    },
    getUserInfo() {
      getUserInfo().then((response) => {
        this.userInfo = response.data;
        this.userInfoForGeneral = Object.assign({}, this.userInfo);
      });
    },
    getDiscountList() {
      let params = {};
      if (this.isGroupEnroll) {
        params = {
          program_product_group: this.programProductGroupSelect.id,
          program_product_num: this.programProductsSelectIDList.length,
          is_group_apply: 1,
        };
      } else {
        params = {
          program_product_group: this.programProductGroupSelect.id,
          program_product_num: this.programProductsSelectIDList.length,
          is_group_apply: 0,
        };
      }
      getDiscountList(params).then((response) => {
        this.discount = [];
        this.discountSelect = [];
        let temp = response.data;

        if (this.programProductGroupSelect.program_type == "TYPE_CAMP") {
          // console.log("寒暑");
          if (this.programProductGroupSelect.is_top_basketball_self) {
            // console.log("自己");
            if (this.isGroupEnroll) {
              // console.log("團報");
              for (let index in temp.discount_plan_data) {
                let item = temp.discount_plan_data[index];
                if (!item.is_expired && item.category == "早鳥類型") {
                  this.discount.push(item);
                  this.discountSelect.push(item);
                }
              }
              for (let index in temp.discount_plan_data) {
                let item = temp.discount_plan_data[index];
                if (!item.is_expired && item.category == "團報類型") {
                  this.discount.push(item);
                }
              }
            } else {
              // console.log("個人");
              if (this.programProductsSelectIDList.length > 1) {
                // console.log("多堂");
                for (let index in temp.discount_plan_data) {
                  let item = temp.discount_plan_data[index];
                  if (
                    !item.is_expired &&
                    (item.category == "早鳥類型" ||
                      item.category == "無贈品續報類型")
                  ) {
                    this.discount.push(item);
                    this.discountSelect.push(item);
                  }
                }
              } else {
                // console.log("單堂");
                for (let index in temp.discount_plan_data) {
                  let item = temp.discount_plan_data[index];

                  if (temp.has_paid_order) {
                    if (
                      !item.is_expired &&
                      (item.category == "早鳥類型" ||
                        item.category == "無贈品續報類型")
                    ) {
                      this.discount.push(item);
                      this.discountSelect.push(item);
                    }
                  } else {
                    if (!item.is_expired && item.category == "早鳥類型") {
                      this.discount.push(item);
                      this.discountSelect.push(item);
                    }
                  }
                }
              }
            }
          } else {
            // console.log("別人");
            if (this.isGroupEnroll) {
              // console.log("團報");
              for (let index in temp.discount_plan_data) {
                let item = temp.discount_plan_data[index];
                if (!item.is_expired && item.category == "團報類型") {
                  this.discount.push(item);
                }
              }
            } else {
              // console.log("個人");
              if (this.programProductsSelectIDList.length > 1) {
                // console.log("多堂");
                for (let index in temp.discount_plan_data) {
                  let item = temp.discount_plan_data[index];
                  if (!item.is_expired && item.category == "多梯次續報類型") {
                    this.discount.push(item);
                    this.discountSelect.push(item);
                  }
                }
                if (this.discount.length == 0) {
                  for (let index in temp.discount_plan_data) {
                    let item = temp.discount_plan_data[index];
                    if (!item.is_expired && item.category == "早鳥類型") {
                      this.discount.push(item);
                      this.discountSelect.push(item);
                    }
                  }
                }
              } else {
                // console.log("單堂");
                for (let index in temp.discount_plan_data) {
                  let item = temp.discount_plan_data[index];
                  if (!item.is_expired && item.category == "早鳥類型") {
                    this.discount.push(item);
                    this.discountSelect.push(item);
                  }
                }
              }
            }
          }
        } else {
          // console.log("常態");
          this.isValueMember = temp.is_value_member;
        }
        this.getDiscountDetail();
      });
    },
    getProductDetail() {
      this.programProductsSelectList = [];
      for (let index in this.programProductsSelectIDList) {
        let temp = this.programProductsSelectIDList[index];
        getProgramProductByID(temp).then((response) => {
          this.programProductsSelectList.push(response.data);
          this.getDiscountDetail();
        });
      }
    },
    getExtraProductDetail() {
      this.selectExtraProductsList = [];
      for (let index in this.selectExtraProductsIDList) {
        let temp = this.selectExtraProductsIDList[index];
        getProgramProductByID(temp).then((response) => {
          response.data.extraProductCount = 1;
          this.selectExtraProductsList.push(response.data);
          this.getDiscountDetail();
        });
      }
    },
    getDiscountDetail() {
      this.discountDetailList = [];
      if (this.programProductGroupSelect.program_type == "TYPE_CAMP") {
        // console.log("寒暑");
        if (this.programProductGroupSelect.is_top_basketball_self) {
          // console.log("自己");
          if (this.isGroupEnroll) {
            // console.log("團報");
            for (let index in this.discountSelect) {
              let temp = this.discountSelect[index];
              if (temp.category == "早鳥類型") {
                let tempDiscountItem = {};
                tempDiscountItem.name = temp.name + " X" + this.totalStudent;
                tempDiscountItem.price = temp.discount * this.totalStudent;
                this.discountDetailList.push(tempDiscountItem);
              } else {
                let tempDiscountItem = {};
                tempDiscountItem.name = temp.name + " X" + this.totalStudent;
                tempDiscountItem.price = temp.discount * this.totalStudent;
                this.discountDetailList.push(tempDiscountItem);
              }
            }
            this.getTotalPrice();
          } else {
            // console.log("個人");
            if (this.programProductsSelectList.length > 1) {
              // console.log("多堂");
              for (let index in this.discountSelect) {
                let temp = this.discountSelect[index];
                if (temp.category == "早鳥類型") {
                  let tempDiscountItem = {};
                  tempDiscountItem.name = temp.name + " X1";
                  tempDiscountItem.price = temp.discount;
                  this.discountDetailList.push(tempDiscountItem);
                }
                if (temp.category == "無贈品續報類型") {
                  let tempDiscountItem = {};
                  tempDiscountItem.name =
                    temp.name +
                    " X" +
                    (this.programProductsSelectList.length - 1);
                  tempDiscountItem.price =
                    temp.discount * (this.programProductsSelectList.length - 1);
                  this.discountDetailList.push(tempDiscountItem);
                }
              }
              this.getTotalPrice();
            } else {
              // console.log("單堂");
              for (let index in this.discountSelect) {
                let temp = this.discountSelect[index];
                let tempDiscountItem = {};
                tempDiscountItem.name = temp.name + " X1";
                tempDiscountItem.price = temp.discount;
                this.discountDetailList.push(tempDiscountItem);
              }
              this.getTotalPrice();
            }
          }
        } else {
          // console.log("別人");
          if (this.isGroupEnroll) {
            // console.log("團報");
            for (let index in this.discountSelect) {
              let temp = this.discountSelect[index];
              if (!temp.is_percent_discount) {
                let tempDiscountItem = {};
                tempDiscountItem.name = temp.name + " X" + this.totalStudent;
                tempDiscountItem.price = temp.discount * this.totalStudent;
                this.discountDetailList.push(tempDiscountItem);
              }
            }
            this.getTotalPrice();
            for (let index in this.discountSelect) {
              let temp = this.discountSelect[index];
              if (temp.is_percent_discount) {
                let coursePrice = 0;
                for (let index in this.programProductsSelectList) {
                  let tempProduct = this.programProductsSelectList[index];
                  coursePrice =
                    coursePrice + tempProduct.total_price * this.totalStudent;
                }

                let tempDiscountItem = {};
                tempDiscountItem.name = temp.name + " X" + this.totalStudent;
                tempDiscountItem.price = (coursePrice * temp.discount) / 100;
                this.discountDetailList.push(tempDiscountItem);
              }
              this.getTotalPrice();
            }
          } else {
            // console.log("個人");
            if (this.programProductsSelectList.length > 1) {
              // console.log("多堂");
              let hasMutiple = false;
              for (let index in this.discountSelect) {
                let temp = this.discountSelect[index];
                if (temp.category == "多梯次續報類型") {
                  hasMutiple = true;
                  break;
                }
              }
              if (hasMutiple) {
                for (let index in this.discountSelect) {
                  let temp = this.discountSelect[index];
                  if (
                    !temp.is_percent_discount &&
                    temp.category == "多梯次續報類型"
                  ) {
                    let tempDiscountItem = {};
                    tempDiscountItem.name =
                      temp.name + " X" + this.programProductsSelectList.length;
                    tempDiscountItem.price =
                      temp.discount * this.programProductsSelectList.length;
                    this.discountDetailList.push(tempDiscountItem);
                  }
                }
                this.getTotalPrice();
                for (let index in this.discountSelect) {
                  let temp = this.discountSelect[index];
                  if (temp.is_percent_discount) {
                    let coursePrice = 0;
                    for (let index in this.programProductsSelectList) {
                      let tempProduct = this.programProductsSelectList[index];
                      coursePrice = coursePrice + tempProduct.total_price;
                    }

                    let tempDiscountItem = {};
                    tempDiscountItem.name = temp.name + " X1";
                    tempDiscountItem.price =
                      (coursePrice * temp.discount) / 100;
                    this.discountDetailList.push(tempDiscountItem);
                  }
                }
                this.getTotalPrice();
              } else {
                for (let index in this.discountSelect) {
                  let temp = this.discountSelect[index];
                  if (
                    !temp.is_percent_discount &&
                    temp.category == "早鳥類型"
                  ) {
                    let tempDiscountItem = {};
                    tempDiscountItem.name =
                      temp.name + " X" + this.programProductsSelectList.length;
                    tempDiscountItem.price =
                      temp.discount * this.programProductsSelectList.length;
                    this.discountDetailList.push(tempDiscountItem);
                  }
                }
                this.getTotalPrice();
                for (let index in this.discountSelect) {
                  let temp = this.discountSelect[index];
                  if (temp.is_percent_discount) {
                    let coursePrice = 0;
                    for (let index in this.programProductsSelectList) {
                      let tempProduct = this.programProductsSelectList[index];
                      coursePrice = coursePrice + tempProduct.total_price;
                    }

                    let tempDiscountItem = {};
                    tempDiscountItem.name = temp.name + " X1";
                    tempDiscountItem.price =
                      (coursePrice * temp.discount) / 100;
                    this.discountDetailList.push(tempDiscountItem);
                  }
                }
                this.getTotalPrice();
              }
            } else {
              // console.log("單堂");
              for (let index in this.discountSelect) {
                let temp = this.discountSelect[index];
                if (!temp.is_percent_discount) {
                  let tempDiscountItem = {};
                  tempDiscountItem.name = temp.name + " X1";
                  tempDiscountItem.price = temp.discount;
                  this.discountDetailList.push(tempDiscountItem);
                }
              }
              this.getTotalPrice();
              for (let index in this.discountSelect) {
                let temp = this.discountSelect[index];
                if (temp.is_percent_discount) {
                  let coursePrice = 0;
                  for (let index in this.programProductsSelectList) {
                    let tempProduct = this.programProductsSelectList[index];
                    coursePrice = coursePrice + tempProduct.total_price;
                  }

                  let tempDiscountItem = {};
                  tempDiscountItem.name = temp.name + " X1";
                  tempDiscountItem.price = (coursePrice * temp.discount) / 100;
                  this.discountDetailList.push(tempDiscountItem);
                }
                this.getTotalPrice();
              }
            }
          }
        }
      } else {
        // console.log("常態");
        if (this.isValueMember) {
          for (let index in this.programProductsSelectList) {
            let temp = this.programProductsSelectList[index];
            let courseCount = temp.total_price / temp.unit_price;
            for (let y in temp.program_product_discount_plans) {
              let discount = temp.program_product_discount_plans[y];
              let tempDiscountItem = {};
              tempDiscountItem.name = discount.name + " X" + courseCount;
              tempDiscountItem.price = discount.discount * courseCount;
              this.discountDetailList.push(tempDiscountItem);
            }
          }
        }
        this.getTotalPrice();
      }
    },
    getTotalPrice() {
      this.total = 0;
      for (let index in this.programProductsSelectList) {
        let tempProduct = this.programProductsSelectList[index];
        this.total = this.total + tempProduct.total_price * this.totalStudent;
      }
      for (let index in this.selectExtraProductsList) {
        let tempExtra = this.selectExtraProductsList[index];
        this.total =
          this.total + tempExtra.total_price * tempExtra.extraProductCount;
      }
      for (let index in this.discountDetailList) {
        let tempDiscount = this.discountDetailList[index];
        this.total = this.total - tempDiscount.price;
      }
    },
    onDiscountSelect(discount) {
      if (this.isGroupEnroll) {
        if (discount.category == "早鳥類型") {
          return;
        } else {
          this.discountSelect = this.discountSelect.filter(function(event) {
            return event.category == "早鳥類型";
          });

          this.discountSelect.push(discount);
          this.totalStudent = discount.group_size;
        }
      }
      this.tabIndex = 0;
      this.tabs = [];
      this.tabCounter = 0;
      this.multipleStudents = [];
      this.getDiscountDetail();
    },
    closeTab(x) {
      this.tabs.splice(x, 1);
      this.multipleStudents.splice(x, 1);
      this.tabCounter--;
    },
    newTab() {
      if (this.tabCounter < this.totalStudent) {
        let temp = Object.assign({}, this.student);
        this.multipleStudents.push(temp);
        this.tabs.push(this.tabCounter++);
      }
    },
    checkOrderStatus() {
      if (this.isGroupEnroll && this.totalStudent <= 1) {
        return "團報必須選擇一張優惠券";
      }
      if (this.totalStudent == 1) {
        let hasError = false;
        let errorMsg = "";
        if (!this.singleStudent.studentName) {
          hasError = true;
        }
        if (
          !this.singleStudent.studentBirthday ||
          this.singleStudent.birthdayValid
        ) {
          hasError = true;
        }
        if (!this.singleStudent.contactPhone) {
          hasError = true;
        }
        if (!this.singleStudent.studentID || this.singleStudent.personIdValid) {
          hasError = true;
        }
        if (!this.singleStudent.school) {
          hasError = true;
        }
        if (!this.singleStudent.parentName) {
          hasError = true;
        }
        if (
          !this.singleStudent.parentBirthday ||
          this.singleStudent.parentBirthdayValid
        ) {
          hasError = true;
        }
        if (!this.singleStudent.parentID || this.singleStudent.parentIdValid) {
          hasError = true;
        }
        if (!this.singleStudent.grade) {
          hasError = true;
        }
        if (!this.singleStudent.basketball_experience) {
          hasError = true;
        }
        if (!this.singleStudent.basketball_goal) {
          hasError = true;
        }
        if (!this.singleStudent.lineID) {
          hasError = true;
        }
        if (!this.singleStudent.healthy) {
          hasError = true;
        }
        if (!this.singleStudent.allergy) {
          hasError = true;
        }
        if (hasError) {
          errorMsg = errorMsg + "請將必填項目填寫完整";
        }

        if (!this.isAgree) {
          if (errorMsg) {
            errorMsg = errorMsg + ", 請勾選同意以上規範";
          } else {
            errorMsg = errorMsg + "請勾選同意以上規範";
          }
        }

        return errorMsg;
      } else {
        if (this.multipleStudents.length == 0) {
          return "請至少新增一位學生";
        } else {
          let errorMsg = "";
          for (let index in this.multipleStudents) {
            let tempStudent = this.multipleStudents[index];
            let count = Number(index) + 1;
            let hasError = false;

            if (!tempStudent.studentName) {
              hasError = true;
            }
            if (!tempStudent.studentBirthday || tempStudent.birthdayValid) {
              hasError = true;
            }
            if (!tempStudent.contactPhone) {
              hasError = true;
            }
            if (!tempStudent.studentID || tempStudent.personIdValid) {
              hasError = true;
            }
            if (!tempStudent.school) {
              hasError = true;
            }
            if (!tempStudent.parentName) {
              hasError = true;
            }
            if (
              !tempStudent.parentBirthday ||
              tempStudent.parentBirthdayValid
            ) {
              hasError = true;
            }
            if (!tempStudent.parentID || tempStudent.parentIdValid) {
              hasError = true;
            }
            if (!tempStudent.grade) {
              hasError = true;
            }
            if (!tempStudent.basketball_experience) {
              hasError = true;
            }
            if (!tempStudent.basketball_goal) {
              hasError = true;
            }
            if (!tempStudent.lineID) {
              hasError = true;
            }
            if (!tempStudent.healthy) {
              hasError = true;
            }
            if (!tempStudent.allergy) {
              hasError = true;
            }

            if (hasError) {
              if (errorMsg) {
                errorMsg = errorMsg + ", 請將學生" + count + "必填項目填寫完整";
              } else {
                errorMsg = errorMsg + "請將學生" + count + "必填項目填寫完整";
              }
            }
          }
          if (!this.isAgree) {
            if (errorMsg) {
              errorMsg = errorMsg + ", 請勾選同意以上規範";
            } else {
              errorMsg = errorMsg + "請勾選同意以上規範";
            }
          }
          return errorMsg;
        }
      }
    },
    onConfirmBtnClick() {
      this.loadingDialogShow = true;
      let errorMsg = this.checkOrderStatus();
      if (errorMsg) {
        errorMessage(this, "警告", errorMsg);
        this.loadingDialogShow = false;
        return;
      }

      let discountPlans = [];
      for (let index in this.discountSelect) {
        let temp = this.discountSelect[index];
        discountPlans.push(temp.id);
      }

      let confirmProductIDList = [];
      for (let index in this.programProductsSelectIDList) {
        let temp = this.programProductsSelectIDList[index];
        confirmProductIDList.push(temp);
      }

      let additionalProductInfo = {};
      for (let index in this.selectExtraProductsList) {
        let temp = this.selectExtraProductsList[index];
        this.$set(
          additionalProductInfo,
          temp.id,
          Number(temp.extraProductCount)
        );
      }

      let students = [];
      if (this.totalStudent == 1) {
        let tempStudent = {
          name: this.singleStudent.studentName,
          citizen_id: this.singleStudent.studentID,
          birthday: this.singleStudent.studentBirthday,
          school: this.singleStudent.school,
          grade: this.singleStudent.grade,
          basketball_experience: this.singleStudent.basketball_experience,
          basketball_goal: this.singleStudent.basketball_goal,
          health_condition: this.singleStudent.healthy,
          food_allergens: this.singleStudent.allergy,
          legal_representative_name: this.singleStudent.parentName,
          legal_representative_birthday: this.singleStudent.parentBirthday,
          legal_representative_citizen_id: this.singleStudent.parentID,
          parent_phone: this.singleStudent.contactPhone,
          parent_line_id: this.singleStudent.lineID,
        };
        students.push(tempStudent);
      } else {
        for (let index in this.multipleStudents) {
          let temp = this.multipleStudents[index];
          let tempStudent = {
            name: temp.studentName,
            citizen_id: temp.studentID,
            birthday: temp.studentBirthday,
            school: temp.school,
            grade: temp.grade,
            basketball_experience: temp.basketball_experience,
            basketball_goal: temp.basketball_goal,
            health_condition: temp.healthy,
            food_allergens: temp.allergy,
            legal_representative_name: temp.parentName,
            legal_representative_birthday: temp.parentBirthday,
            legal_representative_citizen_id: temp.parentID,
            parent_phone: temp.contactPhone,
            parent_line_id: temp.lineID,
          };
          students.push(tempStudent);
        }
      }

      let data = {
        program_product_group: this.programProductGroupSelect.id,
        group_size: this.totalStudent,
        discount_plans: discountPlans,
        program_products: confirmProductIDList,
        additional_product_info: additionalProductInfo,
        program_apply_targets: students,
      };

      confirmOrder(data)
        .then(() => {
          if (this.totalStudent == 1 && this.singleStudent.addNewGeneral) {
            this.updateGeneralList(this.singleStudent);
          } else if (this.totalStudent != 1) {
            for (let index in this.multipleStudents) {
              let temp = this.multipleStudents[index];
              if (temp.addNewGeneral) {
                this.updateGeneralList(temp);
              }
            }
          }
          this.$router.push({ name: "EnrollComplete" });
          this.loadingDialogShow = false;
        })
        .catch((error) => {
          errorMessage(this, "報名失敗", error.response.data.error_msg);
          this.loadingDialogShow = false;
        });
    },
    updateGeneralList(tempStudent) {
      if (this.userInfo.apply_targets.length < 10) {
        let temp = {
          name: tempStudent.studentName,
          citizen_id: tempStudent.studentID,
          birthday: tempStudent.studentBirthday,
          school: tempStudent.school,
          grade: tempStudent.grade,
          basketball_experience: tempStudent.basketball_experience,
          basketball_goal: tempStudent.basketball_goal,
          health_condition: tempStudent.healthy,
          food_allergens: tempStudent.allergy,
          legal_representative_name: tempStudent.parentName,
          legal_representative_birthday: tempStudent.parentBirthday,
          legal_representative_citizen_id: tempStudent.parentID,
          parent_phone: tempStudent.contactPhone,
          parent_line_id: tempStudent.lineID,
        };
        this.userInfo.apply_targets.push(temp);
        updateUserInfo(this.userInfo).then(() => {});
      }
    },
    singleGeneralChange() {
      if (this.singleStudent.generalSelect) {
        this.singleStudent.studentName = this.singleStudent.generalSelect.name;
        this.singleStudent.studentBirthday = this.singleStudent.generalSelect.birthday;
        this.singleStudent.contactPhone = this.singleStudent.generalSelect.parent_phone;
        this.singleStudent.studentID = this.singleStudent.generalSelect.citizen_id;
        this.singleStudent.school = this.singleStudent.generalSelect.school;
        this.singleStudent.parentName = this.singleStudent.generalSelect.legal_representative_name;
        this.singleStudent.parentBirthday = this.singleStudent.generalSelect.legal_representative_birthday;
        this.singleStudent.parentID = this.singleStudent.generalSelect.legal_representative_citizen_id;
        this.singleStudent.grade = this.singleStudent.generalSelect.grade;
        this.singleStudent.basketball_experience = this.singleStudent.generalSelect.basketball_experience;
        this.singleStudent.basketball_goal = this.singleStudent.generalSelect.basketball_goal;
        this.singleStudent.lineID = this.singleStudent.generalSelect.parent_line_id;
        this.singleStudent.healthy = this.singleStudent.generalSelect.health_condition;
        this.singleStudent.allergy = this.singleStudent.generalSelect.food_allergens;
        this.singleStudent.addNewGeneral = false;
      } else {
        this.singleStudent.studentName = "";
        this.singleStudent.studentBirthday = "";
        this.singleStudent.contactPhone = "";
        this.singleStudent.studentID = "";
        this.singleStudent.school = "";
        this.singleStudent.parentName = "";
        this.singleStudent.parentBirthday = "";
        this.singleStudent.parentID = "";
        this.singleStudent.grade = "";
        this.singleStudent.lineID = "";
        this.singleStudent.healthy = "";
        this.singleStudent.allergy = "";
        this.singleStudent.basketball_experience = "";
        this.singleStudent.basketball_goal = "";
      }
    },
    multipleGeneralChange(index) {
      if (this.multipleStudents[index].generalSelect) {
        this.multipleStudents[index].studentName = this.multipleStudents[
          index
        ].generalSelect.name;
        this.multipleStudents[index].studentBirthday = this.multipleStudents[
          index
        ].generalSelect.birthday;
        this.multipleStudents[index].contactPhone = this.multipleStudents[
          index
        ].generalSelect.parent_phone;
        this.multipleStudents[index].studentID = this.multipleStudents[
          index
        ].generalSelect.citizen_id;
        this.multipleStudents[index].school = this.multipleStudents[
          index
        ].generalSelect.school;
        this.multipleStudents[index].parentName = this.multipleStudents[
          index
        ].generalSelect.legal_representative_name;
        this.multipleStudents[index].parentBirthday = this.multipleStudents[
          index
        ].generalSelect.legal_representative_birthday;
        this.multipleStudents[index].parentID = this.multipleStudents[
          index
        ].generalSelect.legal_representative_citizen_id;
        this.multipleStudents[index].grade = this.multipleStudents[
          index
        ].generalSelect.grade;
        this.multipleStudents[
          index
        ].basketball_experience = this.multipleStudents[
          index
        ].generalSelect.basketball_experience;
        this.multipleStudents[index].basketball_goal = this.multipleStudents[
          index
        ].generalSelect.basketball_goal;
        this.multipleStudents[index].lineID = this.multipleStudents[
          index
        ].generalSelect.parent_line_id;
        this.multipleStudents[index].healthy = this.multipleStudents[
          index
        ].generalSelect.health_condition;
        this.multipleStudents[index].allergy = this.multipleStudents[
          index
        ].generalSelect.food_allergens;
        this.multipleStudents[index].addNewGeneral = false;
      } else {
        this.multipleStudents[index].studentName = "";
        this.multipleStudents[index].studentBirthday = "";
        this.multipleStudents[index].contactPhone = "";
        this.multipleStudents[index].studentID = "";
        this.multipleStudents[index].school = "";
        this.multipleStudents[index].parentName = "";
        this.multipleStudents[index].parentBirthday = "";
        this.multipleStudents[index].parentID = "";
        this.multipleStudents[index].grade = "";
        this.multipleStudents[index].lineID = "";
        this.multipleStudents[index].healthy = "";
        this.multipleStudents[index].allergy = "";
        this.multipleStudents[index].basketball_experience = "";
        this.multipleStudents[index].basketball_goal = "";
      }
    },
    personIdChange(type, studentID, student) {
      let tempStudentID = studentID.toUpperCase();
      if ("S" == type) {
        if (validID(tempStudentID)) {
          student.personIdValid = false;
        } else {
          student.personIdValid = true;
        }
      } else {
        if (validID(tempStudentID)) {
          student.parentIdValid = false;
        } else {
          student.parentIdValid = true;
        }
      }
    },
    birthdayChange(type, birthday, student) {
      if ("S" == type) {
        if (validDateExist(birthday)) {
          student.birthdayValid = false;
        } else {
          student.birthdayValid = true;
        }
      } else {
        if (validDateExist(birthday)) {
          student.parentBirthdayValid = false;
        } else {
          student.parentBirthdayValid = true;
        }
      }
    },
  },
};
</script>

<style scoped lang="scss">
@import "@/assets/style/enroll/enroll";
</style>
